module.exports = __webpack_public_path__ + "img/private.3865a316.png";